<template>
  <div v-if="workspaceID" v-bind:class="isDesktopCards ? 'desktop-cards' : 'normal'">
    <noray-auth v-if="type === 'noray'" :workspaceID="workspaceID" />
    <char-auth v-else-if="type === 'char'" />
    <dfiles-auth v-else-if="type === 'dfiles'" :isDesktopCards="isDesktopCards" />
  </div>
</template>
<script>
import {
  mapState
} from 'vuex'
import NorayAuth from './NorayAuth'
import CharAuth from '@/components/CharAuth'
import DfilesAuth from '@/components/DfilesAuth'
export default {
  components: {
    NorayAuth,
    CharAuth,
    DfilesAuth
  },
  props: {
    type: {
      type: String,
      default: null,
    },
    isDesktopCards: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    workspaceID: null,
  }),
  computed: {
    ...mapState('app',['dtouchWorkspace']),
  },
  watch: {
    dtouchWorkspace () {
      this.workspaceID = this.dtouchWorkspace
    },
  },
  mounted () {
    this.workspaceID = this.dtouchWorkspace
  },
}
</script>
<style scoped>
.desktop-cards {
  position: fixed;
  top: 13px; 
  right: 55px;
  z-index: 100;
  text-shadow: 1px 1px gray;

}
.desktop-cards * {
  text-shadow: 1px 1px gray;
}
</style>

